module.exports = __webpack_public_path__ + "auto-approve-content-modal-entry.0a2d690efa5d3556eb6ae4a22e9eb85e.png";